import DebitCreditCode from '@/models/Shared/DebitCreditCode';

export default (debitCreditCode: DebitCreditCode) => {
    let returnVal = "Undefined";
    switch (debitCreditCode) {
        case DebitCreditCode.debit: {
            returnVal = "Debit"
            break;
        }
        case DebitCreditCode.credit: {
            returnVal = "Credit"
            break;
        }
    }
    return returnVal;
}